import { createSelector } from '@ngrx/store';

import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { managersAdapter } from './managers.reducer';

export const getManagersState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.managers
);
export const {
  selectIds: getManagersIds,
  selectEntities: getManagersEntities,
  selectAll: getManagersAll,
  selectTotal: getManagersTotal
} = managersAdapter.getSelectors(getManagersState);

export const getManager = createSelector(
  getManagersEntities,
  (entities, props) => !!entities && entities[props.id]
);

